// Fotky kolegyň v avatarových slotech šablony (header, patička, poradce na
// detailu, tmavé panely kontaktů / klientské sekce / info stránek).
//
// Slot = MÍSTO v šabloně, ne osoba: casting se mění jedním řádkem v `PHOTOS`,
// moduly o souborech nevědí. Prázdná hodnota = slot drží ikonu sluchátek,
// takže vypnutí fotek je jeden řádek a ne revert kódu.
//
// Soubory vyrábí `python tools/media/web-avatars.py` ze sady `assets/team/`
// do `assets/media/`, na web je nese `deploy/upload-media.ps1` (mimo `dist/`,
// stejně jako hero média). Retuš a ořezy: assets/team/README.md.

import { icon } from './icon.js';

import { MEDIA } from './instanceUrl.js';

// Cutouty (`-light` / `-dark`) jsou z bílé zdi složené na plochu pozadí slotu,
// `-store` je reálná fotka z prodejny — patří jen tam, kde je kolem ní prostor
// a foto na bílé by působilo jako průkazka (rozhodnutí Tomáše 2026-08-27).
// Přípona NENÍ volba vzhledu: říká, na jakou barvu je cutout složený, takže
// tmavý slot musí vzít `-dark`, jinak kolem tváře svítí světlý čtverec.
//
// Sada z 2026-09-04 (zadání Tomáše): Veronika i Andrea mají nové fotky,
// hlavička patří Andree, Nikol zůstává na sadě z 2026-08-26.
const PHOTOS = {
  header: 'team-andrea-light-160.jpg',
  drawer: 'team-veronika-dark-160.jpg', // karta podpory v mobilním menu (tmavý podklad)
  footer: 'team-nikol-light-160.jpg',
  advisor: 'team-veronika-light-160.jpg',
  contact: 'team-veronika-dark-160.jpg',
  customer: 'team-nikol-dark-160.jpg',
  infoHelp: 'team-nikol-dark-160.jpg',
  // Sekce Tým na kontaktech (2026-08-31): každý člen svou tvář, podpora nese
  // Nikol, ať se jedna tvář neopakuje ve dvou kartách.
  teamVeronika: 'team-veronika-light-160.jpg',
  teamAndrea: 'team-andrea-light-160.jpg',
  teamSupport: 'team-nikol-light-160.jpg',
};

export function teamPhotoUrl(slot) {
  return PHOTOS[slot] ? MEDIA + PHOTOS[slot] : '';
}

// Naplní avatarový slot fotkou, jinak ikonou. Fotka, která se nenačte (výpadek
// CDN, nenahraná dávka médií), se tiše vymění zpět za ikonu — prázdné kolečko
// vypadá jako chyba šablony. `has-photo` na slotu shazuje tint pozadí v SCSS.
export function fillAvatar(host, slot, size, fallbackIcon) {
  const name = fallbackIcon || 'headset';
  const url = teamPhotoUrl(slot);
  if (!url) {
    host.appendChild(icon(name));
    return host;
  }
  const img = document.createElement('img');
  img.className = 'bs-avatar-photo';
  img.src = url;
  img.alt = '';
  img.width = size;
  img.height = size;
  img.loading = 'lazy';
  img.decoding = 'async';
  img.addEventListener('error', function () {
    img.remove();
    host.classList.remove('has-photo');
    if (!host.querySelector('.bs-icon')) host.appendChild(icon(name));
  });
  host.classList.add('has-photo');
  host.appendChild(img);
  return host;
}
